import { memo, useMemo, useState } from 'react';

import AllAppointmentTypeScheduleExpectationCycles from '@/components/AppointmentTypesByPhaseList/components/AllAppointmentTypeScheduleExpectationCycles';
import AppointmentTypeScheduleExpectationCyclesWithinLookahead from '@/components/AppointmentTypesByPhaseList/components/AppointmentTypeScheduleExpectationCyclesWithinLookahead';
import { Alert } from '@/ui';
import { PillSwitch, PillSwitchOption } from '@/ui';

import type { Props } from './types';

const AppointmentTypesByPhaseList = ({
  activeAppointmentTypeId,
  onSeeExpectationDetails,
  phase,
  timeZone
}: Props) => {
  const [viewAllScheduleExpectations, setViewAllScheduleExpectations] = useState(false);

  const renderContent = useMemo(() => {
    return viewAllScheduleExpectations ? (
      <AllAppointmentTypeScheduleExpectationCycles
        onSeeExpectationDetails={onSeeExpectationDetails}
        phase={phase}
        timeZone={timeZone}
      />
    ) : (
      <AppointmentTypeScheduleExpectationCyclesWithinLookahead
        activeAppointmentTypeId={activeAppointmentTypeId}
        onSeeExpectationDetails={onSeeExpectationDetails}
        phase={phase}
        timeZone={timeZone}
      />
    );
  }, [
    activeAppointmentTypeId,
    onSeeExpectationDetails,
    phase,
    timeZone,
    viewAllScheduleExpectations
  ]);

  return (
    <>
      <div className="flex justify-end items-center gap-3 my-2">
        <span className="text-sm text-uniform-gray-600">View mode</span>
        <PillSwitch
          value={viewAllScheduleExpectations ? 'historical' : 'current'}
          onChange={(v) => setViewAllScheduleExpectations(v === 'historical')}
          size="sm"
          color="neutral">
          <PillSwitchOption value="current">Current</PillSwitchOption>
          <PillSwitchOption value="historical">Historical</PillSwitchOption>
        </PillSwitch>
      </div>

      {viewAllScheduleExpectations && (
        <div className="mb-2">
          <Alert variant="info">
            It is not advised to use historical mode unless you are troubleshooting. Please disable
            it to see visual indicators for met expectations.
          </Alert>
        </div>
      )}

      {renderContent}
    </>
  );
};
export default memo(AppointmentTypesByPhaseList);
